<div class="download-button-wrapper">
  <p>{{ labels.title }}</p>
  <button class="download-button" (click)="openDialog()">
    {{ labels.download }}
  </button>
</div>
